import { settingsButton } from '@tma.js/sdk-react'
import { useEffect, useEffectEvent } from 'react'

type TelegramSettingsButtonProps = {
  isVisible: boolean
  onClick: () => void
}

export const TelegramSettingsButton = ({
  isVisible,
  onClick,
}: TelegramSettingsButtonProps) => {
  const handleClick = useEffectEvent(onClick)

  useEffect(() => {
    if (isVisible) {
      settingsButton.show.ifAvailable()
    } else {
      settingsButton.hide.ifAvailable()
    }
  }, [isVisible])

  useEffect(() => {
    if (!isVisible) {
      return
    }

    const offClick = settingsButton.onClick.ifAvailable(() => {
      handleClick()
    })

    return () => {
      if (offClick.ok) {
        offClick.data()
      }
    }
  }, [isVisible])

  return null
}
